import React, { Component } from 'react';
import axios from 'axios';

class KLDataAll extends Component {
  constructor(props){
      super(props);
      this.state = {
          klData:[],
          search:''
      }
      this.picUrl = 'http://klimports.com/data/images/carpets/';
      // this.picUrl = 'http://localhost:3000/data/images/carpets/'

      this.handleOnChange = this.handleOnChange.bind(this);
  }

  componentDidMount(){
      axios.get('../../data/kl_data_carpet.json')
      .then(res =>{
          const klData = res.data;
          this.setState({klData});
      });
  }

  handleOnChange(e){
    this.setState({search:e.target.value});
    console.log(this.state.search);
  }

  render() {

    // let filteredContent = this.state.klData;

    let filteredData = this.state.klData;
    
    let filteredContent = filteredData.filter(
        (product) => {
            return product.FIELD2.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1;;
        }
    );
    return (
      <div className="App">
    {/* <div className ="container-fluid search-wrapper">
      <div className="row off-block">
     <div class="col-md-12"><h2><strong>Rugs 50% OFF</strong></h2></div>
    </div>
    </div> */}
    <div className ="container carpet-block">
      <div className="row">
        {filteredContent.map(product => {
        return(
        <div className="col-md-6 col-sm-4 .col-6 itemblock">
             <img src= {this.picUrl + product.FIELD9} alt= {product.image} />  
            <div className="product-discription item-number"><strong>Item No:</strong> {product.FIELD2}</div>
            <div className="product-discription"><strong>Quality:</strong> {product.FIELD3}</div>
            <div className="product-discription"><strong>Construction:</strong> {product.FIELD4}</div>
            <div className="product-discription"><strong>Size:</strong> {product.FIELD5}</div>
            <div className="product-discription"><strong>Weight:</strong> {product.FIELD7} <strong>lb</strong></div>
            <div className="product-discription product-price"><strong>Price:</strong> <span className="discount">${product.FIELD8}</span> <span>${(product.FIELD8 * 50 / 100).toFixed(0)}</span></div>
        </div>
        )}
        )}
    </div>
      </div>
      </div>
    );
  }
}

export default KLDataAll;